
    import Vue from 'vue';

    
      import i18n from '@/i18n';
  const $t = i18n.t.bind(i18n);

    
const userMap = {
  'status': 500,
  'message': $t('5fe6cc0473e0d313'),
  'data': {
    'ncpc': true,
    'redirectUrl': '/dashboard'
  }
}
const userInfo = {
  'status': 200,
  'code': 'maskit.success.general',
  'message': 'Maskit general success',
  'data': [
    {
      'id': '391',
      'userId': '55031',
      'displayName': $t('ff09e2c6d332d9a9'),
      'name': $t('e700c28686cf9239'),
      'accountId': '1057158895652',
      'account': '4611686018427442935',
      'districtId': '101',
      'orgId': '1',
      'posts': [{
        'id': '51',
        'name': $t('ac4b9e617b460217'),
        'otherName': '',
        'isInterview': true,
        'isTrain': false,
        'isJob': false,
        'isManager': true,
        'description': $t('cf9e55be6bc85b96'),
        'createdAt': '1513164352000',
        'updatedAt': '1513164352000',
        'type': 2,
        'status': 1,
        'orgId': '517443',
        'employNumber': 1,
        'employType': 0
      }],
      'postName': [$t('ac4b9e617b460217'), $t('2b68d9152e3d3db1')],
      'postID': '31',
      'orgBriefMsgs': [{
        'id': '2',
        'name': $t('051d6d3c0467ce2c'),
        'type': 3,
        'categories': ['', '']
      }],
      'orgName': $t('8d7d36bc6fb6d6ac'),
      'orgDepPosts': ['1', '2'],
      'deps': [{
        'id': '515630',
        'name': $t('2c3949540a8af2b2')
      }],
      'depId': '515630',
      'depName': $t('2c3949540a8af2b2'),
      'job': $t('5cabbc13e4bee21a'),
      'type': $t('5cabbc13e4bee21a'),
      'empNo': '1',
      'isManager': true,
      'manageDep': $t('42c4c030fab33ead'),
      'managerId': '4611686018427442767',
      'managerName': 'jack',
      'phone': '13588887873',
      'faxNo': '9871-1819',
      'email': 'a@sina.com',
      'hiredAt': '1513164352000',
      'status': 0,
      'createdAt': '1513164352000',
      'updatedAt': '1513164352000'
    }
  ]
}
export default {
  loginByUsername: config => {
    // const { username } = JSON.parse(config.body)
    return {
      "status": 401,
      "error": "oneid.account.not.allow.login",
      "message": "please change password firstly",
      "timestamp": "1513164352000",
      "data": {
        "resetToken" : "06565e84-28f7-4cda-8c87-8932745c542c",
        "expireAt" : "1583264352000"
      }
    }
  },
  getUserInfo: config => {
    return userInfo
  },
  logout: () => 'success',
  encryptionPwd: () => {
//     return {
//       status: 200,
//       data: {
//         random: 10,
//         publicKey: `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOJu6TyygqxfWT7eLtGDwajtN
// FOb9I5XRb6khyfD1Yt3YiCgQWMNW649887VGJiGr/L5i2osbl8C9+WJTeucF+S76
// xFxdU6jE0NQ+Z+zEdhUTooNRaY5nZiu5PgDB0ED/ZKBUSLKL7eibMxZtMlUDHjm4
// gwQco1KRMDSmXSMkDwIDAQAB`
//       }
//     }
    return {
      "status": 200,
      "error": "maskit.success.general",
      "message": "maskit.success.general",
      "timestamp": "1519682709154",
      "data": {
        "algorithm": "AES",
        "random": "765ADF46342CF24D",
        "iv": "BA831F00D33BC9B1"
      },
      "path": null
    }
  },
  getCurrent: config => {
    return {
      'id': '112233445566',
      'mainAccountId': null,
      'mainAccount': null,
      'accountId': '112233445566',
      'account': 'Foo',
      'type': '',
      'displayName': 'Foo',
      'avatarUrl': '',
      'status': 0,
      'email': 'foo@bar.com',
      'mobile': '15888888888',
      'currentCategory': '10',
      'portalCategories': ['10'],
      'userCategories': ['10'],
      'activate': 1,
      'districtId': '310000',
      'orgId': 1001,
      'orgName': $t('54f11cc55ea6122f'),
      'depId': 1001,
      'depName': $t('d115f29ef6edb41f'),
      'orgBriefMsgs': [{
        'id': 10001,
        'name': $t('3417a5fcc3a35dec'),
        'type': '1',
        'categories': ''
      }],
      'depBriefMsgs': [{
        'id': 20001,
        'orgId': 1001,
        'name': $t('7bd27a06c47deebb')
      }],
      'shopId': 10002000
    }
  },
  getNcAppKey: config => {
    return {
      status: 200,
      data: 'CF_APP_1'
    }
  },
  sendForgetEmail: config => {
    return {
      status: 200,
      data: true
    }
  },
  sendForgetMobile: config => {
    return {
      status: 200,
      data: true
    }
  },
  checkCodeForPassword: config => {
    return {
      status: 200,
      data: true
    }
  },
  resetPasswordAfterCheckCode: config => {
    return {
      status: 200,
      data: true
    }
  },
  fetchDomain: config => {
    return {
      'status': 200,
      'error': 'maskit.success.general',
      'message': 'Maskit general success',
      'timestamp': '1515719185851',
      'data': {
        'UAA': 'http://local.uaa.egrp.top:9081',
        'WEB': 'http://dev.suser.svwsx.cn/'
      }
    }
  },
  getPasswordPattern: config => {
    return {
      "status": 200,
      "error": "maskit.success.general",
      "message": $t("465d732d68ebdfbb"),
      "timestamp": "1531163802219",
      "data": {
        "regular": "(?!^[\\dA-Z]+$)(?!^[\\da-z]+$)(?!^[\\d`~!@#$%^&*()_-]+$)(?!^[A-Za-z]+$)(?!^[A-Z`~!@#$%^&*()_-]+$)(?!^[a-z`~!@#$%^&*()_-]+$)^[a-zA-Z\\d`~!@#$%^&*()_-]{10,16}$",
        "errorMessage": $t("d3ad9f48039d6f36"),
        "prompt": $t("9b9a980dcdf8e51a")
      },
      "path": null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/login.js